const type = 'SET_CUSTOMER_ADDRESSES_HISTORY';

const setCustomerAddressesHistory = (data) => ({
  data,
  type,
});

export { type };
export default setCustomerAddressesHistory;
